import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type StorageGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

/**
 * Shows children only when dayReservableAreas module is enabled in module config.
 */
export const StorageGate: React.FC<StorageGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { storages } = useModuleConfig()
  return storages.enabled ? children : <Navigate to={redirectTo} replace />
}
